import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.01 3.42007L18.91 6.04007C20.61 6.79007 20.61 8.03007 18.91 8.78007L13.01 11.4001C12.34 11.7001 11.24 11.7001 10.57 11.4001L4.67002 8.78007C2.97002 8.03007 2.97002 6.79007 4.67002 6.04007L10.57 3.42007C11.24 3.12007 12.34 3.12007 13.01 3.42007Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 11.5C3 12.34 3.63 13.31 4.4 13.65L11.19 16.67C11.71 16.9 12.3 16.9 12.81 16.67L19.6 13.65C20.37 13.31 21 12.34 21 11.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 16.5C3 17.43 3.55 18.27 4.4 18.65L11.19 21.67C11.71 21.9 12.3 21.9 12.81 21.67L19.6 18.65C20.45 18.27 21 17.43 21 16.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgProject;
